import React from 'react';
import ServiceItem from "./serviceItem";

const ServiceItems = ({services}) => {
    return (
        <div className="item">
            <ul className="service__list">
                {services && services.map(service => <ServiceItem key={service.id} service={service}/>)}
            </ul>
        </div>
    );
};

export default ServiceItems;
